import React, { useRef } from 'react';
import { FaUpload, FaTrash } from 'react-icons/fa';
import { handleLogoFileChange } from '../utils/logoUpload';

/**
 * Reusable Company Logo uploader.
 * Props:
 *  - logo: string | null (data URL)
 *  - setLogo: (dataUrl|null) => void
 *  - label?: string
 *  - accent?: string
 */
const LogoUploader = ({ logo, setLogo, label = 'Company Logo', accent = '#2563eb' }) => {
  const inputRef = useRef(null);

  return (
    <div className="input-group">
      <label>{label}</label>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          padding: 12,
          border: `1.5px dashed ${accent}`,
          borderRadius: 10,
          background: '#f8fafc',
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 10,
            background: '#fff',
            border: '1px solid #e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          {logo ? (
            <img
              src={logo}
              alt="Logo preview"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          ) : (
            <span style={{ color: '#9ca3af', fontSize: 11 }}>No logo</span>
          )}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12.5, color: '#6b7280', marginBottom: 6 }}>
            Upload a PNG/JPG/SVG (max 1.5 MB). Shown on PDF & preview.
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => inputRef.current && inputRef.current.click()}
              style={{ padding: '6px 12px' }}
            >
              <FaUpload /> {logo ? 'Replace Logo' : 'Upload Logo'}
            </button>
            {logo && (
              <button
                type="button"
                className="btn btn-outline"
                onClick={() => setLogo(null)}
                style={{ padding: '6px 12px' }}
              >
                <FaTrash /> Remove
              </button>
            )}
          </div>
          <input
            ref={inputRef}
            type="file"
            accept="image/png,image/jpeg,image/svg+xml,image/webp"
            style={{ display: 'none' }}
            onChange={(e) => handleLogoFileChange(e, setLogo)}
          />
        </div>
      </div>
    </div>
  );
};

export default LogoUploader;
